export class FeeTypePricingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFeeTypes(params) {
    return this.#http.get('api/fee-types', { params });
  }

  async createFeeType(body) {
    return this.#http.post('api/fee-types', body);
  }

  async editFeeType({ feeTypeId, ...body }) {
    return this.#http.put(`api/fee-types/${feeTypeId}`, body);
  }

  async deleteFeeType({ feeTypeId }) {
    return this.#http.delete(`api/fee-types/${feeTypeId}`);
  }

  async getOverride({ feeTypeId }) {
    return this.#http.get(`api/fee-types/${feeTypeId}/override`);
  }

  async createOrUpdateOverride({ feeTypeId, ...body }) {
    return this.#http.put(`api/fee-types/${feeTypeId}/override`, body);
  }

  async deleteOverride({ feeTypeId }) {
    return this.#http.delete(`api/fee-types/${feeTypeId}/override`);
  }
}
